
import React from 'react';
import { useApp } from '../context/AppContext';
import { Home, Wallet, Clock, Settings, User } from 'lucide-react';

const BottomNavigation: React.FC = () => {
  const { setCurrentScreen, currentScreen } = useApp();

  const navItems = [
    { icon: Home, label: 'Home', screen: 'dashboard' },
    { icon: Wallet, label: 'New', screen: 'transaction' },
    { icon: Clock, label: 'History', screen: 'history' },
    { icon: Settings, label: 'Settings', screen: 'settings' },
  ];

  return (
    <div className="mobile-bottom-nav fixed bottom-0 left-0 right-0 bg-white z-30">
      {navItems.map((item) => (
        <button 
          key={item.screen}
          className={`mobile-bottom-nav-item ${currentScreen === item.screen ? 'text-neobank-primary' : 'text-gray-500'}`}
          onClick={() => setCurrentScreen(item.screen)}
        >
          <item.icon className="w-6 h-6 mb-1" />
          <span>{item.label}</span>
        </button>
      ))}
    </div>
  );
};

export default BottomNavigation;
